<template>
  <div class="row">
    <div class="col-12 mt-3 mb-5">
      <h2>Select a Channel</h2>
    </div>
    <div class="col-12">
      <transition-group name="list" tag="div" class="row">
        <div v-for="c in channels" :key="c.id" class="col-sm-6 col-md-4 col-lg-3">
          <ChannelCard :channel="c" />
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import Config from '@/config'
export default {
  name: 'SelectChannelView',
  data () {
    return {
      channels: Config.staticChannels
    }
  },
  mounted () {
    // Only showing Football; just redirect there
    window.location.href = '/#/channels/gslsjbxbxopgb8rpilyn'
  },
  watch: {
    '$route' (to, from) {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style>
.list-enter-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.list-leave-active {
  transition: none;
}
.list-enter, .list-leave-to {
  opacity: 0.5;
  transform: scale(.95);
}
</style>



// WEBPACK FOOTER //
// src/components/SelectChannelView.vue